import type { BuildingChatSections } from "../../../types/buildings-sections/chat";

export const chat: BuildingChatSections = {
  title: "Vestle oma hoonega",
  placeholder: "Küsi oma hoone kohta...",
  error: "Vastuse saamine ebaõnnestus. Palun proovige uuesti.",
  errorMessage: "Midagi läks valesti. Vestluse jätkamiseks värskendage vestlust.",
  refreshChat: "Värskenda vestlust",
  helpSubtitle: "Kuidas saan teid oma hoone haldamisel aidata?",
};
